import { Component, OnInit } from '@angular/core';
import { DxButtonTypes } from 'devextreme-angular/ui/button';
import { firstValueFrom } from 'rxjs';
import { StaticPageCreateDto } from 'src/app/shared/dtos/staticPage/staticPageCreateDto';
import { StaticPageUpdateDto } from 'src/app/shared/dtos/staticPage/staticPageUpdateDto';
import { PageType } from 'src/app/shared/enums/pageType';
import { StaticPageService } from 'src/app/shared/services';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { NotificationService } from 'src/app/shared/services/notification.service';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss'],
})
export class BlogComponent implements OnInit {
  constructor(
    private staticPageService: StaticPageService,
    private loadingService: LoadingService,
    private notificationService: NotificationService
  ) {}

  dataSource: any;
  popupVisible: boolean = false;
  isVisibleEditor: boolean = false;
  toolbarButtonOptions: DxButtonTypes.Properties = {
    text: 'Ön İzleme',
    stylingMode: 'text',
    onClick: () => (this.popupVisible = true),
  };

  editorOptions: any = {
    height: 500,
    toolbar: {
      items: [
        'undo',
        'redo',
        'separator',
        'bold',
        'italic',
        'strike',
        'underline',
        'alignLeft',
        'separator',
        'alignLeft',
        'alignCenter',
        'alignRight',
        'alignJustify',
        'orderedList',
        'bulletList',
        'separator',
        {
          name: 'size',
          acceptedValues: [
            '6pt',
            '8pt',
            '9pt',
            '10pt',
            '12pt',
            '14pt',
            '18pt',
            '24pt',
            '36pt',
            '45pt',
          ],
          options: { inputAttr: { 'aria-label': 'Font size' } },
        },
        {
          name: 'size',
          acceptedValues: [
            'Arial',
            'Courier New',
            'Georgia',
            'Impact',
            'Lucida Console',
            'Tahoma',
            'Times New Roman',
            'Verdana',
            '36pt',
            '45pt',
          ],
          options: { inputAttr: { 'aria-label': 'Font' } },
        },
        {
          name: 'header',
          acceptedValues: [false, 1, 2, 3, 4, 5, 6],
          options: { inputAttr: { 'aria-label': 'Header' } },
        },
        // {
        //   widget: 'dxButton',
        //   options: {
        //     text: 'Ön İzleme',
        //     stylingMode: 'text',
        //     onClick: () => (this.popupVisible = true),
        //   },
        // },
      ],
    },
  };

  ngOnInit(): void {
    this.getList();
  }

  async getList() {
    this.staticPageService.getByPageType(PageType.Blog).subscribe((data) => {
      this.dataSource = data;
    });
  }

  async createBlog(event: any) {
    this.loadingService.show();
    var createBlogDto: StaticPageCreateDto = {
      title: event.data.title,
      content: event.data.content,
      tag: event.data.tag,
      pageType: PageType.Blog,
      metaKeyword: event.data.metaKeyword,
      metaDescription: event.data.metaDescription,
      imageUrl: event.data.imageUrl,
      isWebSiteList: event.data.isWebSiteList,
    };
    await firstValueFrom(this.staticPageService.create(createBlogDto));
    await this.getList()
    this.notificationService.show('Başarı ile kayıt oluşturuldu.');
    this.loadingService.hide();
  }
  async updateBlog(event: any) {
    this.loadingService.show();
    var updateBlogDto: StaticPageUpdateDto = {
      id: event.oldData.id,
      title: event.newData.title ?? event.oldData.title,
      content: event.newData.content ?? event.oldData.content,
      tag: event.newData.tag ?? event.oldData.tag,
      pageType: event.oldData.pageType,
      metaKeyword: event.newData.metaKeyword ?? event.oldData.metaKeyword,
      metaDescription: event.newData.metaDescription ?? event.oldData.metaDescription,
      imageUrl: event.newData.imageUrl ?? event.oldData.imageUrl,
      isWebSiteList: event.newData.isWebSiteList ?? event.oldData.isWebSiteList,
    };
    await firstValueFrom(this.staticPageService.update(updateBlogDto.id, updateBlogDto));
    await this.getList()
    this.notificationService.show('Kayıt güncellendi.');
    this.loadingService.hide();
  }

  async deleteBlog(event: any) {
    this.loadingService.show();
    await firstValueFrom(this.staticPageService.delete(event.key));
    await this.getList()
    this.notificationService.show('Kayıt silindi.');
    this.loadingService.hide();
  }

  async onFileSelected(base64: any, rowData:any) {
    this.loadingService.show();
    var updateBlogDto: StaticPageUpdateDto = {
      id: rowData.id,
      title: rowData.title,
      content: rowData.content,
      tag: rowData.tag,
      pageType: rowData.pageType,
      metaKeyword: rowData.metaKeyword,
      metaDescription:rowData.metaDescription,
      imageUrl: rowData.imageUrl,
      isWebSiteList: rowData.isWebSiteList,
      selectedFileBase64: base64,
    };
    await firstValueFrom(this.staticPageService.update(updateBlogDto.id, updateBlogDto));
    await this.getList()
    this.notificationService.show('Resim Yüklendi');
    this.loadingService.hide();
  }
  onInitNewRow(event:any){
    event.data.isWebSiteList = false;
  }
}
